import SurveyQrCode from '@components/SurveyQrCode/SurveyQrCode';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';

interface SatisfactionSurveyQrPreviewProps {
  url: string;
  size?: number;
}

const SatisfactionSurveyQrPreview = ({ url, size = 120 }: SatisfactionSurveyQrPreviewProps) => {
  const { translate } = useTranslation();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'flex-start' }}>
      <Typography variant="body2" color="textSecondary">
        {translate(LangEnum.SATISFACTION_SURVEY_SETTINGS_QR_PREVIEW)}
      </Typography>
      <SurveyQrCode url={url} size={size} variant="outlined" />
    </Box>
  );
};

export default SatisfactionSurveyQrPreview;
